import type { TokenConfig } from "../types";

export const ETHEREUM_MAINNET_TOKENS: TokenConfig[] = [
  {
    symbol: "USDC",
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    decimals: 6,
    vaultAddresses: [],
  },
  {
    symbol: "WETH",
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    decimals: 18,
    vaultAddresses: [],
  },
];

export const POLYGON_MAINNET_TOKENS: TokenConfig[] = [
  {
    symbol: "USDC",
    address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
    decimals: 6,
    vaultAddresses: [
      "0xAcB0DCe4b0FF400AD8F6917f3ca13E434C9ed6bC"
    ],
  },
];

export const BASE_MAINNET_TOKENS: TokenConfig[] = [
  {
    symbol: "USDC",
    address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    decimals: 6,
    vaultAddresses: [
      "0xcdDCDd18A16ED441F6CB10c3909e5e7ec2B9e8f3",
      "0x1D3b1Cd0a0f242d598834b3F2d126dC6bd774657",
      "0x5435BC53f2C61298167cdB11Cdf0Db2BFa259ca0",
      "0x23479229e52Ab6aaD312D0B03DF9F33B46753B5e",
      "0xef417a2512C5a41f69AE4e021648b69a7CdE5D03",
      "0x12AFDeFb2237a5963e7BAb3e2D46ad0eee70406e",
      "0xE74c499fA461AF1844fCa84204490877787cED56",
      "0x75e1A1f9535C01CDcE25E51ea4aFF0d171337E1F",
      "0xBEEFE94c8aD530842bfE7d8B397938fFc1cb83b2",
      "0xeE8F4eC5672F09119b96Ab6fB59C27E1b7e44b61",
      "0x236919F11ff9eA9550A4287696C2FC9e18E6e890",
      "0x43e623Ff7D14d5b105F7bE9c488F36dbF11D1F46",
      "0xBEEFA7B88064FeEF0cEe02AAeBBd95D30df3878F",
      "0xbeeF010f9cb27031ad51e3333f9aF9C6B1228183",
      "0x616a4E1db48e22028f6bbf20444Cd3b8e3273738",
      "0x1401d1271C47648AC70cBcdfA3776D4A87CE006B",
      "0xc0c5689e6f4D256E861F65465b691aeEcC0dEb12",
      "0x7BfA7C4f149E7415b73bdeDfe609237e29CBF34A",
      "0xc1256Ae5FF1cf2719D4937adb3bbCCab2E00A2Ca",
      "0xCd347c1e7d600a9A3e403497562eDd0A7Bc3Ef21",
      "0xCBeeF01994E24a60f7DCB8De98e75AD8BD4Ad60d",
      "0xB7890CEE6CF4792cdCC13489D36D9d42726ab863",
      "0x8773447e6369472D9B72f064Ea62e405216E9084",
    ],
  },
  {
    symbol: "WETH",
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    vaultAddresses: [
      "0x5A32099837D89E3a794a44fb131CBbAD41f87a8C",
      "0x09832347586E238841F49149C84d121Bc2191C53",
      "0x27D8c7273fd3fcC6956a0B370cE5Fd4A7fc65c18",
      "0xa0E430870c4604CcfC7B38Ca7845B1FF653D0ff1",
      "0xbEEf050a7485865A7a8d8Ca0CC5f7536b7a3443e",
      "0x1D795E29044A62Da42D927c4b179269139A28A6B",
      "0x6b13c060F13Af1fdB319F52315BbbF3fb1D88844",
    ],
  },
  {
    symbol: "cbBTC",
    address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
    decimals: 8,
    vaultAddresses: [
      "0x543257eF2161176D7C8cD90BA65C2d4CaEF5a796",
      "0x6770216aC60F634483Ec073cBABC4011c94307Cb",
      "0x5a47C803488FE2BB0A0EAaf346b420e4dF22F3C7",
    ],
  },
];
